import { render, staticRenderFns } from "./ConfigSlot.vue?vue&type=template&id=de0bb474&scoped=true"
import script from "./ConfigSlot.vue?vue&type=script&lang=js"
export * from "./ConfigSlot.vue?vue&type=script&lang=js"
import style0 from "./ConfigSlot.vue?vue&type=style&index=0&id=de0bb474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0bb474",
  null
  
)

export default component.exports